export default "__VITE_ASSET__q9eZa5YL__"